<script>
export default {
  name: "sepomex-address-form",
  data: () => ({
    form: {
      colId: null,
      cp: null,
      estadosId: null,
      munId: null,
      locId: null,
    },
    neighborhoods: [],
    states: [],
    municipalities: [],
  }),
  watch: {
    form: {
      deep: true,
      handler(val) {
        this.$emit('onChange', val);
      }
    },
    'form.colId': function (val) {
      let neighborhoods = this.neighborhoods.filter((v) => v.coloniaId === val)
      if (neighborhoods.length > 0) {
        this.form.locId = neighborhoods[0].tipoLocalidadId;
      }
    }
  },
  methods: {
    changeCpHandler() {
      if (this.form.cp === null)
        return;
      this.fetchNeighborhoods(this.form.cp)
    },
    async fetchNeighborhoods(cp) {
      this.$vs.loading();
      try {
        const {data} = await axios.get(`/api/backoffice/common/neighborhood/zipcode/${cp}`);
        this.neighborhoods = data
        if (this.neighborhoods.length > 0) {
          let firstNeighborhood = this.neighborhoods[0];

          //await this.fetchStates();
          //await this.fetchMunicipalities();
          this.states = [firstNeighborhood.city.state];
          this.form.estadosId = firstNeighborhood.city.state.sepomex_code;

          this.municipalities = [firstNeighborhood.city];
          this.form.munId = firstNeighborhood.city.sepomex_code;
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.$vs.loading.close();
      }
    },
    async fetchStates() {
      const {data} = await axios.get('/api/condusef/redeco/states');
      this.states = data;
      this.$vs.loading.close();
    },
    async fetchMunicipalities() {
      if (this.form.estadosId !== null && this.form.cp !== null) {
        this.$vs.loading();
        try {
          const {data} = await axios.get(`/api/condusef/redeco/municipalities?stateId=${this.form.estadosId}&cp=${this.form.cp}`);
          this.municipalities = data;
        } catch (e) {
          console.error(e);
        } finally {
          this.$vs.loading.close();
        }
      }
    },
  }
}
</script>

<template>
  <vx-card title="Datos de dirección">
    <div class="grid grid-cols-3 gap-3">
      <vs-input
          class="w-full"
          @keyup.enter="changeCpHandler"
          @blur="changeCpHandler" label="Código postal" v-model="form.cp"/>
      <vs-select class="w-full" label="Estado"  v-if="states.length > 0" v-model="form.estadosId">
        <vs-select-item
            v-for="state in states"
            :key="state.sepomex_code"
            :value="state.sepomex_code"
            :text="state.name"/>
      </vs-select>
      <vs-select class="w-full" label="Municipio" v-model="form.munId" v-if="municipalities.length > 0">
        <vs-select-item
            v-for="m in municipalities"
            :key="m.sepomex_code"
            :value="m.sepomex_code"
            :text="m.name"/>
      </vs-select>
      <vs-select class="w-full" label="Colonia" v-model="form.colId" v-if="neighborhoods.length > 0">
        <vs-select-item
            v-for="neighborhood in neighborhoods"
            :key="neighborhood.sepomex_code"
            :value="neighborhood.sepomex_code"
            :text="neighborhood.name"/>
      </vs-select>
    </div>
  </vx-card>
</template>